<div class="card">
    <div class="card-header">
        <div class="row">
            <div class="col"> Remark</div>
            <div class="col-auto">
                <button *ngIf="this.common.PageRight.IsView" class="btn btn-sm btn-primary" name="Viewprofile"
                    (click)="ViewProfile()">
                    <i class="bi bi-person-lines-fill" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'ViewProfile':'Loading...'}}
                </button>&nbsp;&nbsp;
                <button *ngIf="this.common.PageRight.IsView" class="btn btn-sm btn-primary" name="Viewuniform"
                    (click)="ViewUniform()">
                    <i class="bi bi-ui-checks" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Uniform Details':'Loading...'}}
                </button>&nbsp;&nbsp;
                <button *ngIf="this.common.PageRight.IsView" type="button" class="btn btn-sm btn-primary"
                    name="attandancedetails" (click)="ViewAttandance()">
                    <i class="bi bi-person-raised-hand" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Attendance':'Loading...'}}
                </button> &nbsp;&nbsp;
                <button *ngIf="this.common.PageRight.IsView" type="button" class="btn btn-sm btn-primary"
                    name="salarydtails" (click)="ViewSalaryDetails()">
                    <i class="bi bi-ticket-detailed-fill" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Salary Details':'Loading...'}}
                </button>
                <!-- <button *ngIf="this.common.PageRight.IsView" class="btn btn-sm btn-primary" name="salaryslip"
                    (click)="ViewSalarySlip()">
                    <i class="bi bi-ticket-detailed-fill" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Salary Slip':'Loading...'}}
                </button> -->
            </div>
        </div>
    </div>
    <div class="card-body" style="overflow: auto; height: 460px;">
        <div class="container">
            <div class="row">
                <div class="col-md mx-1 px-1 bghighlight">
                    <label class="text-label">Employee</label><br />
                    <label class="Label1">
                        <div class="row no-gutters cursor-pointer" style="align-items: center;width: 300px;">
                            <div class="col-2">
                                <img *ngIf="InputData.Photo != null && InputData.Photo != ''" mat-card-image
                                    class="userImage" [src]="common.PhotoLink(InputData.Photo)" />
                                <div *ngIf="InputData.Photo == null || InputData.Photo == ''" class="initial-image">
                                    <div class="image">
                                        {{common.getInitial(InputData.EmpName)}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-9 userdetail">
                                <span class="text-label">{{InputData.EmpName}}</span><br />
                                <span class="text-label-light">#{{InputData.EmpCode}}</span><br />
                                <span class="text-label-light">{{InputData.DesignationName}}</span>
                            </div>
                        </div>
                    </label>
                </div>
                <div class="col-md mx-1 px-1 bghighlight">
                    <div class="row">
                        <div class="text-label">Complaint ID</div>
                    </div>
                    <div class="row text-right" style="font-size: 15px;">
                        <div>{{InputData.ESS_HelpDeskRequestId}} </div>
                    </div>
                </div>
                <div class="col-md mx-1 px-1 bghighlight">
                    <div class="row">
                        <div class="text-label">Complaint Type</div>
                    </div>
                    <div class="row text-right" style="font-size: 15px;">
                        <div>{{InputData.ComplaintType}}</div>
                    </div>
                </div>
                <div class="col-md mx-1 px-1 bghighlight">
                    <div class="row">
                        <div class="text-label">Contact No.</div>
                    </div>
                    <div class="row text-right" style="font-size: 15px;">
                        <div>{{InputData.EmpContact}}</div>
                    </div>
                </div>
            </div>
            <div class="row" style="margin-top: 3px;">
                <div class="col-md mx-1 px-1 bghighlight">
                    <div class="row">
                        <div class="text-label">Branch</div>
                    </div>
                    <div class="row text-right" style="font-size: 15px;">
                        <div>{{InputData.BranchName}}</div>
                    </div>
                </div>
                <div class="col-md mx-1 px-1 bghighlight">
                    <div class="row">
                        <div class="text-label">Client</div>
                    </div>
                    <div class="row text-right" style="font-size: 15px;">
                        <div>{{InputData.ClientLocation}}</div>
                    </div>
                </div>
                <div class="col-md mx-1 px-1 bghighlight">
                    <div class="row">
                        <div class="text-label">Site</div>
                    </div>
                    <div class="row text-right" style="font-size: 15px;">
                        <div>{{InputData.SiteName}}</div>
                    </div>
                </div>
                <div class="col-md mx-1 px-1 bghighlight">
                    <div class="row">
                        <div class="text-label">Site Supervisor</div>
                    </div>
                    <div class="row text-right" style="font-size: 15px;">
                        <div>{{InputData.SiteSuperVisorName}}</div>
                    </div>
                </div>
            </div>
            <div class="row" style="margin-top: 3px;">
                <div class="col-md mx-1 px-1 bghighlight">
                    <div class="row">
                        <div class="text-label">Site Supervisor Email</div>
                    </div>
                    <div class="row text-right" style="font-size: 15px;">
                        <div>{{InputData.SupervisorEmailId}}</div>
                    </div>
                </div>
                <div class="col-md mx-1 px-1 bghighlight">
                    <div class="row">
                        <div class="text-label">Site Supervisor Contact no</div>
                    </div>
                    <div class="row text-right" style="font-size: 15px;">
                        <div>{{InputData.SupervisorContactNo}}</div>
                    </div>
                </div>
                <div class="col-md mx-1 px-1 bghighlight">
                    <div class="row">
                        <div class="text-label">Description</div>
                    </div>
                    <div class="row text-right" style="font-size: 15px;">
                        <div>{{InputData.Description}}</div>
                    </div>
                </div>
            </div>

            <div class="row">
                <!-- <div class="col-md-3">
                    <label class="small-light-label heading">Complaint ID</label><br />
                    <label class="Label1">{{InputData.ESS_HelpDeskRequestId}}</label>
                </div>
                <div class="col-md-3">
                    <label class="small-light-label heading">Complaint Type</label><br />
                    <label class="Label1">{{InputData.ComplaintType}}</label>
                </div> -->
                <div class="col-md-6">
                    <!-- <label class="small-light-label heading">Employee</label><br />
                    <label class="Label1"> -->
                    <!-- {{InputData.EmpName}}({{InputData.EmpCode}}) -->
                    <!-- <div class="row no-gutters cursor-pointer" style="align-items: center;width: 300px;">
                            <div class="col-2">
                                <img *ngIf="InputData.Photo != null && InputData.Photo != ''" mat-card-image
                                    class="userImage" [src]="common.PhotoLink(InputData.Photo)" />
                                <div *ngIf="InputData.Photo == null || InputData.Photo == ''" class="initial-image">
                                    <div class="image">
                                        {{common.getInitial(InputData.EmpName)}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-9 userdetail">
                                <span class="text-label">{{InputData.EmpName}}</span><br />
                                <span class="text-label-light">#{{InputData.EmpCode}}</span><br />
                                <span class="text-label-light">{{InputData.DesignationName}}</span>
                            </div>
                        </div>
                    </label> -->
                </div>
            </div>
            <div class="row">
                <!-- <div class="col-md-3">
                    <label class="small-light-label heading">Contact No.</label><br />
                    <label class="Label1">{{InputData.EmpContact}} </label>
                </div> -->
                <!-- <div class="col-md-3">
                    <label class="small-light-label heading">Branch</label><br />
                    <label class="Label1"> {{InputData.BranchName}}</label>
                </div>
                <div class="col-md-3">
                    <label class="small-light-label heading">Client</label><br />
                    <label class="Label1"> {{InputData.ClientLocation}}</label>
                </div>
                <div class="col-md-3">
                    <label class="small-light-label heading">Site</label><br />
                    <label class="Label1">{{InputData.SiteName}} </label>
                </div> -->
            </div>
            <!-- <div class="row">        
                <div class="col-md-3">
                    <label class="small-light-label heading">Site Supervisor</label><br />
                    <label class="Label1"> {{InputData.SiteSuperVisorName}}</label>
                </div>
            </div> -->
            <div class="row">
                <!-- <div class="col-md-3">
                    <label class="small-light-label heading">Site Supervisor</label><br />
                    <label class="Label1">{{InputData.SiteSuperVisorName}}</label>
                </div> -->
                <!-- <div class="col-md-3">
                    <label class="small-light-label heading">Site Supervisor Email</label><br />
                    <label class="Label1"> {{InputData.SupervisorEmailId}}</label>
                </div>
                <div class="col-md-3">
                    <label class="small-light-label heading">Site Supervisor Contact no</label><br />
                    <label class="Label1">{{InputData.SupervisorContactNo}}</label>
                </div> -->
            </div>
            <!-- <div class="row">
                <div class="col-md">
                    <label class="small-light-label heading">Description</label><br />
                    <label class="Label1">{{InputData.Description}}</label>
                </div>
            </div> -->
            <hr *ngIf="InputData.Status.toLowerCase() !== 'closed'">
            <div class="row m-1" *ngIf="InputData.Status.toLowerCase() !== 'closed'">
                <!-- <div class="col-md-5 px-1">
                    <label style="font-size: 14px;">Name <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" id="Name" name="name" [(ngModel)]="Name" #name="ngModel"
                        required>
                </div> -->
                <div class="col-md-4 px-1">
                    <label for="ComplaintType" class="Label">Complaint Type <span class="text-danger">*</span></label>
                    <ng-select [items]="ComplaintTypeData" bindLabel="ComplaintType" bindValue="ESS_ComplaintTypeID"
                        placeholder="Complaint Type" [(ngModel)]="ESS_ComplaintTypeId" [virtualScroll]="true"
                        name="ComplaintType" required>
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select Complaint Type
                    </div>
                </div>
                <div class="col-md-12 px-1">
                    <label style="font-size: 14px;">Remarks <span class="text-danger">*</span></label>
                    <textarea class="form-control" id="Remar" rows="4" placeholder="Please Enter Remarks"
                        [(ngModel)]="Remarks"></textarea>
                </div>
                <div class="col-md-4 px-1">
                    <label class="form-font-label" style="font-size: 14px;">File Upload </label>
                    <div class="file-input-container">
                        <input class="form-control form-control-sm" id="formFileSm" type="file" *ngIf="!Attachment"
                            (change)="onFileSelected($event)" accept=".pdf,image/*" />
                        <span *ngIf="Attachment" class="file-name">{{ Attachment
                            }}</span>
                        <span *ngIf="Attachment "> <button class="btn btn-sm" name="view" type="button"
                                style="color: blue;" (click)="viewFile()"><i class="bi bi-eye"></i></button></span>
                        <button class="btn btn-sm" name="delete" type="button" *ngIf="Attachment"
                            (click)="removeFile()">
                            <i class="bi bi-trash"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button class="btn btn-sm btn-outline-primary" name="cancel" (click)="Close(false)">
                    <i class="bi bi-x-lg" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}
                </button>&nbsp;&nbsp;
                <button
                    *ngIf="(this.common.PageRight.IsAdd || this.common.PageRight.IsEdit) && InputData.Status.toLowerCase() !== 'closed'"
                    class="btn btn-sm btn-primary" name="save" (click)="save()">
                    <i class="bi bi-save" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Save and Close':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>